import React, { useRef, useState } from "react";
import BasicImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { isMobile, isTablet } from "../../utils";
import { Box, Zoom } from "@mui/material";
import { DrawerModal } from "./DrawerModal";
import { Button } from "@mui/material";
import ZoomOutMapOutlinedIcon from "@mui/icons-material/ZoomOutMapOutlined";
import ZoomPanPinch from "./ZoomPan";
import { isDesktop } from "react-device-detect";
import MuiAlert from "./MuiAlert";

interface IImageGalleryProps {
  images: {
    original: string;
    thumbnail: string;
    altText: string;
  }[];
}

export const ImageGallery: React.FC<IImageGalleryProps> = ({ images }) => {
  const [isImageModalOpen, setImageModalOpen] = useState(false);
  const [zoomImageURL, setZoomImageURL] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const handleImageZoom = (imageURL: string) => {
    setZoomImageURL(imageURL);
    setImageModalOpen(true);
  };
  const openImageModal = () => {
    setImageModalOpen(true);
  };
  const closeImageModal = () => setImageModalOpen(false);

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        sx={{
          position: "absolute",
          top: "12px",
          left: "12px",
          borderRadius: "50px", // Make the borderRadius smaller for a square button
          width: "32px", // Set width and height for the smaller button
          height: "40px",
          backgroundColor: "#ffffff95", // Use RGBA format for opacity (80% opacity)
          color: "#2c3e50",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", // Add a subtle shadow effect
          "&:hover": {
            backgroundColor: "#f0f0f095", // Use RGBA format for hover state (80% opacity)
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.4)", // Increase shadow on hover
          },
          zIndex: 1,
        }}
        onClick={() => handleImageZoom(images[currentImageIndex].original)}
      >
        <ZoomOutMapOutlinedIcon sx={{ fontSize: "1.5rem" }} />
      </Button>
      <div className="custom-gallery-container">
        <BasicImageGallery
          items={images}
          infinite={true}
          showFullscreenButton={false}
          useBrowserFullscreen={false}
          showBullets={false} // Hide bullets
          showThumbnails={images.length === 1 ? false : true}
          thumbnailPosition="bottom"
          slideOnThumbnailOver={false}
          showPlayButton={false} // Hide play button
          showNav={false} // Hide arrows
          lazyLoad={true}
          onSlide={(currentIndex) => setCurrentImageIndex(currentIndex)}
          renderItem={(item: any) => (
            <>
              <img
                src={item.original}
                alt={item.altText}
                style={{
                  objectFit: "contain",
                  width: "100%",
                  height: isMobile ? "325px" : isTablet ? "480px" : "640px",
                }}
                className="custom-gallery-image"
                onClick={() => handleImageZoom(item.original)}
              />
            </>
          )}
        />
      </div>
      <DrawerModal
        isOpen={isImageModalOpen}
        onClose={closeImageModal}
        onOpen={openImageModal}
        anchor={"top"}
      >
        <Box
          sx={{
            width: "100%",
            height: "650px",
            overflow: "hidden",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "@media (max-width: 768px)": {
              height: "90vh",
            },
          }}
        >
          <MuiAlert
            text={
              isDesktop
                ? "Double-click or use the mouse wheel to zoom in and out."
                : "Double tap or pinch to zoom."
            }
            type="info"
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 1,
              backgroundColor: "white",
              borderRadius: "12px",
            }}
          />
          <ZoomPanPinch>
            <img
              src={zoomImageURL}
              alt={images[currentImageIndex].altText}
              style={{
                maxHeight: "650px",
                maxWidth: "100%",
                objectFit: "contain",
              }}
            />
          </ZoomPanPinch>
        </Box>
      </DrawerModal>
    </>
  );
};
